import React, { Component, createRef } from 'react';
import './Mirror.css';
import User from '../../User';
import Library from '../../scene/utility/Library';
import Img from '../../StableImage';
import Lightbox from '../utility/Lightbox';
import gallery from '../../library/gallery.json'

import { read } from '../../TextManager';

function getCupSize(cdInCm) {
    if (cdInCm < 2.5) return "AA";

    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const index = Math.floor((cdInCm - 2.5) / 2.5);
    return letters[index];
}

export default class Mirror extends Component {

  constructor(props) {

    super(props);
  }

  state = {
  }

  render () {

    const champion = Library.getChampion(User.champion);
    let portrait;
    for (let i = User.data.level; !portrait; i--)
      portrait = gallery[User.champion].portraits[i];

    return (
      <div className="lightbox-container mirror-page">
        <div className="lightbox-inner" onClick={this.props.onClose}>
          <div className="mirror-main">
            <div className="mirror-text">
              <div className="mirror-comment">
                "{ portrait.comment }"
              </div>
              <div className="mirror-info">
                { portrait.requirement ? <div className="gallery-description-section"><b>Requirement:&nbsp;</b>{portrait.requirement}</div> : "" }
                { portrait.height ? <div className="gallery-description-section"><b>Height:&nbsp;</b>{(portrait.height >= 100 ? (portrait.height/100) + "m" : portrait.height + "cm") + " / " + Math.floor(portrait.height * 0.0328084) + "'" + Math.round((portrait.height * 0.0328084 - Math.floor(portrait.height * 0.0328084)) * 12) + "\""}</div> : "" }
                { portrait.dick ? <div className="gallery-description-section"><b>Dick size:&nbsp;</b>{(portrait.dick >= 100 ? (portrait.dick/100) + "m" : portrait.dick + "cm") + " / " + Math.floor(portrait.dick * 0.0328084) + "'" + Math.round((portrait.dick * 0.0328084 - Math.floor(portrait.dick * 0.0328084)) * 12) + "\""}</div> : "" }
                { portrait.bust ? <div className="gallery-description-section"><b>Bust size:&nbsp;</b>{(portrait.bust >= 100 ? (portrait.bust/100) + "m" : portrait.bust + "cm") + " / " + Math.floor(portrait.bust * 0.0328084) + "'" + Math.round((portrait.bust * 0.0328084 - Math.floor(portrait.bust * 0.0328084)) * 12) + "\"" + (getCupSize(portrait.bust) ? " (" + getCupSize(portrait.bust) + ")" : "")}</div> : "" }
                { portrait.lift ? <div className="gallery-description-section"><b>Deadlift:&nbsp;</b>{(portrait.lift) + "kg" + " / " + Math.floor(portrait.lift * 2.20462) + "lbs"}</div> : "" }
              </div>  
            </div>
            <div className="mirror-image">
              <Img src={portrait.img[0]}/>
            </div> 
          </div> 
        </div>
      </div>
    );
  }
}

